// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  width: 100%;
  padding: 20px 20px 20px 20px;
  margin-top: 20px;
}

.info {
  font-weight: 600;
  display: block;
}

.sub-info {
  display: block;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  order: 1;
  padding: 5px 0px 5px 0px;
}

.info-address {
  font-size: 15px;
  font-weight: 600;
}

input[type=radio] + .fa,
input[type=radio] + label > .fa {
  cursor: pointer;
}

.show-detail {
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}
.show-detail .list {
  text-align: right;
  margin: 20px -14px 0px 0px;
}
.show-detail .list .detail-toggle .fa {
  margin-right: 5px;
}

.hide {
  display: none;
}

.title {
  margin-left: 12px;
  font-weight: 600;
  font-size: 18px;
}

.body {
  font-size: 16px;
  font-weight: 400;
  margin-left: 4px;
}

.form-control {
  border: none;
  border-bottom: 2px solid var(--color-primary);
  background-color: #ffffff;
  border-radius: 0;
  padding: 10px 0px 0px 0px;
}

.form-control:focus {
  border-color: var(--color-primary);
  box-shadow: none;
}

.input-group:focus-within {
  border-radius: 2px;
  border: 1.5px solid black;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

.form-group > label {
  position: absolute;
  top: 24px;
  transform: translateY(-50%);
  left: 13px;
  color: #737373;
  font-size: 16px;
  transition: 0.2s ease-out;
  font-weight: normal;
  z-index: 1;
}

.form-group > label.active {
  top: 11px;
  font-size: 12px;
  color: #007a9d;
}

input {
  overflow: visible;
}

.item-selection-section {
  margin-top: 20px;
  margin-bottom: 20px;
}
.item-selection-section .info-address {
  font-size: 15px;
  font-weight: 600;
}
.item-selection-section .centered-text {
  margin-top: 5%;
}

.sub-content {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  flex: none;
  order: 1;
}

.continue {
  margin-top: 5%;
  background-color: white;
  border: 2px solid #007a9d;
  border-radius: 2px;
  width: 100%;
  height: 40px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.cardTitle {
  font-weight: 600;
  margin-top: 1%;
  margin-bottom: 3%;
  font-size: large;
}

.dateTime {
  font-weight: 600;
}

.btn {
  background: transparent;
  border: 1px solid lightgrey;
}

a {
  text-decoration: underline;
}

.tab-color {
  color: #495057;
}

.delivery-options {
  display: inline-grid;
  margin-left: 5px;
}
.delivery-options .list {
  padding-top: 24px;
}
.delivery-options .list .details {
  margin-right: 5px;
}
.delivery-options .list .semi-bold {
  font-weight: 600;
}
.delivery-options .list-items {
  margin-left: 16px;
  margin-right: 16px;
}
.delivery-options .margin-info-text {
  margin-bottom: 16px;
}
.delivery-options .image {
  width: 100%;
  margin-top: 16px;
}

.editaddr {
  font-size: medium;
  font-weight: 600;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  color: var(--color-interaction-text);
}

.error {
  margin: 20px 0px 0px 0px;
}

input.form-control {
  height: 30px;
  padding: 0px 0px 4px 0px;
  background-color: var(--color-card-background);
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  color: var(--color-card-text);
}

.form-group {
  position: relative;
}
.form-group i {
  border-bottom: 2px solid var(--color-primary);
  padding: 8px 5px 0px 0px;
  font-size: 12px;
}

.form-group label + input.form-control {
  padding-top: 20px;
  height: 45px;
}

input:not(:placeholder-shown) + label,
input:focus + label {
  transform: translate(0, 0) scale(1);
  cursor: pointer;
}

.date-header,
.time-header {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
}

select {
  border: none;
  border-bottom: 2px solid var(--color-primary);
  height: 30px;
  width: 100%;
}

.table-header {
  border-bottom: 1px solid var(--color-primary);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
}

.header-title {
  color: var(--color-interaction-text);
}

.table-content {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  border-top: 1px solid var(--color-secondary);
}

.extended-content {
  height: 35px;
}

.mapDetails {
  margin-top: 3%;
}

.warning {
  max-width: 45px;
  margin: 10px 5px 0px 0px;
  color: #4f4f4f;
  font-size: 18px;
}

.free-text {
  border: none;
  border-bottom: 2px solid var(--color-primary);
  background-color: #ffffff;
  border-radius: 0;
  padding: 3px 0px 0px 0px;
  width: 300px;
}

.map-details {
  z-index: 100;
}

.google-map .map-info-window {
  display: block !important;
  opacity: 1;
  visibility: visible;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
}

.m-screen-header-wrapper {
  position: relative;
  z-index: 100;
}

.google-map {
  display: block;
}
.google-map .map-container {
  height: 300px !important;
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/return-options/return-options.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,4BAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AACA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;EACA,wBAAA;AAEF;;AAAA;EACE,eAAA;EACA,gBAAA;AAGF;;AAAA;;EAEE,eAAA;AAGF;;AADA;EACE,oBAAA;EACA,qBAAA;AAIF;AAHE;EACE,iBAAA;EACA,0BAAA;AAKJ;AAHM;EACE,iBAAA;AAKR;;AACA;EACE,aAAA;AAEF;;AACA;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AAEF;;AAAA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,YAAA;EACA,6CAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AAGF;;AADA;EACE,kCAAA;EACA,gBAAA;AAIF;;AAFA;EACE,kBAAA;EACA,yBAAA;AAKF;;AAHA;EACE,qBAAA;EACA,qBAAA;AAMF;;AAJA;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AAOF;;AALA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAQF;;AANA;EACE,iBAAA;AASF;;AANA;EACE,gBAAA;EACA,mBAAA;AASF;AAPE;EACE,eAAA;EACA,gBAAA;AASJ;AAPE;EACE,cAAA;AASJ;;AALA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;AAQF;;AANA;EACE,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;AASF;;AAPA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAUF;;AARA;EACE,gBAAA;AAWF;;AARA;EACE,uBAAA;EACA,2BAAA;AAWF;;AATA;EACE,0BAAA;AAYF;;AAVA;EACE,cAAA;AAaF;;AAXA;EACE,oBAAA;EACA,gBAAA;AAcF;AAbE;EACE,iBAAA;AAeJ;AAdI;EACE,iBAAA;AAgBN;AAdI;EACE,gBAAA;AAgBN;AAbE;EACE,iBAAA;EACA,kBAAA;AAeJ;AAbE;EACE,mBAAA;AAeJ;AAZE;EACE,WAAA;EACA,gBAAA;AAcJ;;AAXA;EACE,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,YAAA;EACA,oCAAA;AAcF;;AAXA;EACE,wBAAA;AAcF;;AAXA;EACE,YAAA;EACA,wBAAA;EACA,8CAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AAcF;;AAXA;EACE,kBAAA;AAcF;AAbE;EACE,6CAAA;EACA,wBAAA;EACA,eAAA;AAeJ;;AAZA;EACE,iBAAA;EACA,YAAA;AAeF;;AAZA;;EAEE,mCAAA;EACA,eAAA;AAeF;;AAbA;;EAEE,kBAAA;EACA,iBAAA;EACA,eAAA;AAgBF;;AAdA;EACE,YAAA;EACA,6CAAA;EACA,YAAA;EACA,WAAA;AAiBF;;AAfA;EACE,6CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAkBF;;AAfA;EACE,oCAAA;AAkBF;;AAhBA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,4CAAA;AAmBF;;AAjBA;EACE,YAAA;AAoBF;;AAlBA;EACE,cAAA;AAqBF;;AAnBA;EACE,eAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;AAsBF;;AAnBA;EACE,YAAA;EACA,6CAAA;EACA,yBAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;AAsBF;;AAnBA;EACE,YAAA;AAsBF;;AAnBA;EACE,yBAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;AAsBF;;AAnBA;EACE,kBAAA;EACA,YAAA;AAsBF;;AAnBA;EACE,cAAA;AAsBF;AArBC;EACA,wBAAA;EACA,sBAAA;AAuBD","sourcesContent":[".card {\n  width: 100%;\n  padding: 20px 20px 20px 20px;\n  margin-top: 20px;\n}\n\n.info {\n  font-weight: 600;\n  display: block;\n}\n.sub-info {\n  display: block;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  order: 1;\n  padding: 5px 0px 5px 0px;\n}\n.info-address {\n  font-size: 15px;\n  font-weight: 600;\n}\n\ninput[type=\"radio\"] + .fa,\ninput[type=\"radio\"] + label > .fa {\n  cursor: pointer;\n}\n.show-detail {\n  flex: 0 0 66.666667%;\n  max-width: 66.666667%;\n  .list {\n    text-align: right;\n    margin: 20px -14px 0px 0px;\n    .detail-toggle {\n      .fa {\n        margin-right: 5px;\n      }\n    }\n  }\n}\n\n.hide {\n  display: none;\n}\n\n.title {\n  margin-left: 12px;\n  font-weight: 600;\n  font-size: 18px;\n}\n.body {\n  font-size: 16px;\n  font-weight: 400;\n  margin-left: 4px;\n}\n\n.form-control {\n  border: none;\n  border-bottom: 2px solid var(--color-primary);\n  background-color: #ffffff;\n  border-radius: 0;\n  padding: 10px 0px 0px 0px;\n}\n.form-control:focus {\n  border-color: var(--color-primary);\n  box-shadow: none;\n}\n.input-group:focus-within {\n  border-radius: 2px;\n  border: 1.5px solid black;\n}\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n.form-group > label {\n  position: absolute;\n  top: 24px;\n  transform: translateY(-50%);\n  left: 13px;\n  color: #737373;\n  font-size: 16px;\n  transition: 0.2s ease-out;\n  font-weight: normal;\n  z-index: 1;\n}\n.form-group > label.active {\n  top: 11px;\n  font-size: 12px;\n  color: #007a9d;\n}\ninput {\n  overflow: visible;\n}\n\n.item-selection-section {\n  margin-top: 20px;\n  margin-bottom: 20px;\n\n  .info-address {\n    font-size: 15px;\n    font-weight: 600;\n  }\n  .centered-text {\n    margin-top: 5%;\n  }\n}\n\n.sub-content {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  flex: none;\n  order: 1;\n}\n.continue {\n  margin-top: 5%;\n  background-color: white;\n  border: 2px solid #007a9d;\n  border-radius: 2px;\n  width: 100%;\n  height: 40px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n}\n.cardTitle {\n  font-weight: 600;\n  margin-top: 1%;\n  margin-bottom: 3%;\n  font-size: large;\n}\n.dateTime {\n  font-weight: 600;\n}\n\n.btn {\n  background: transparent;\n  border: 1px solid lightgrey;\n}\na {\n  text-decoration: underline;\n}\n.tab-color {\n  color: #495057;\n}\n.delivery-options {\n  display: inline-grid;\n  margin-left: 5px;\n  .list {\n    padding-top: 24px;\n    .details {\n      margin-right: 5px;\n    }\n    .semi-bold {\n      font-weight: 600;\n    }\n  }\n  .list-items {\n    margin-left: 16px;\n    margin-right: 16px;\n  }\n  .margin-info-text {\n    margin-bottom: 16px;\n  }\n\n  .image {\n    width: 100%;\n    margin-top: 16px;\n  }\n}\n.editaddr {\n  font-size: medium;\n  font-weight: 600;\n  background-color: rgba(0, 0, 0, 0);\n  border: none;\n  color: var(--color-interaction-text);\n}\n\n.error {\n  margin: 20px 0px 0px 0px;\n}\n\ninput.form-control {\n  height: 30px;\n  padding: 0px 0px 4px 0px;\n  background-color: var(--color-card-background);\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 16px;\n  color: var(--color-card-text);\n}\n\n.form-group {\n  position: relative;\n  i {\n    border-bottom: 2px solid var(--color-primary);\n    padding: 8px 5px 0px 0px;\n    font-size: 12px;\n  }\n}\n.form-group label + input.form-control {\n  padding-top: 20px;\n  height: 45px;\n}\n\ninput:not(:placeholder-shown) + label,\ninput:focus + label {\n  transform: translate(0, 0) scale(1);\n  cursor: pointer;\n}\n.date-header,\n.time-header {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 12px;\n}\nselect {\n  border: none;\n  border-bottom: 2px solid var(--color-primary);\n  height: 30px;\n  width: 100%;\n}\n.table-header {\n  border-bottom: 1px solid var(--color-primary);\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.header-title {\n  color: var(--color-interaction-text);\n}\n.table-content {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 16px;\n  border-top: 1px solid var(--color-secondary);\n}\n.extended-content {\n  height: 35px;\n}\n.mapDetails {\n  margin-top: 3%;\n}\n.warning {\n  max-width: 45px;\n  margin: 10px 5px 0px 0px;\n  color: #4f4f4f;\n  font-size: 18px;\n}\n\n.free-text {\n  border:none;\n  border-bottom: 2px solid var(--color-primary);\n  background-color: #ffffff;\n  border-radius: 0;\n  padding: 3px 0px 0px 0px;\n  width:300px\n}\n\n.map-details {\n  z-index: 100;\n}\n\n.google-map .map-info-window {\n  display: block !important;\n  opacity: 1;\n  visibility: visible;\n  background-color: white;\n  border: 1px solid #ccc;\n  padding: 10px;\n}\n\n.m-screen-header-wrapper {\n  position: relative;\n  z-index: 100;\n}\n\n.google-map {\n  display: block;\n .map-container {\n height: 300px !important;\n width: 100% !important;\n}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
